import React, {FC} from 'react';
import {
  CollapsableCardBodyItemContainer,
  CollapsableCardLabel,
  CollapsableCardValue
} from "@securspace/securspace-ui-kit";
import {SlotType} from "../../types/Slots";
import {useSlotOrDefault} from "../../hooks/slots/useSlotOrDefault";

// Extend standard div props instead of using the broken OverridableComponent interface in this repo
type CollapsableCardHeaderItemProps = React.ComponentPropsWithoutRef<'div'> & {
  value: SlotType
  label: SlotType
  secondaryLabel?: string;
  secondaryValue?: string;
}

const CollapsableCardHeaderItemWithSecondaryLabel: FC<CollapsableCardHeaderItemProps> = ({value, label, secondaryLabel, secondaryValue, ...rest}) => {
  // define slots
  const Label = useSlotOrDefault(label, CollapsableCardLabel);
  const Value = useSlotOrDefault(value ?? '-', CollapsableCardValue);

  return <CollapsableCardBodyItemContainer {...rest}>
    {Label}
    {Value}
    {secondaryLabel}
    {secondaryValue}
  </CollapsableCardBodyItemContainer>
}

export { CollapsableCardHeaderItemWithSecondaryLabel };
